import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { useFlags } from '../../../contexts/LDContext';

import { SharedBillingForm } from './Form';
import { SharedBillingFormV2 } from './FormV2';
import { useAccounts } from './useAccounts';
import { useOrganizers } from './useOrganizers';

export { sharedBillingValidationSchema } from './Form';
export { sharedBillingValidationSchemaV2 } from './FormV2';

export { ConfirmationModal } from './ConfirmationModal';

export const SharedBilling = ({ riderId }: { riderId?: string }) => {
  const { userFeatures } = useAuthQuery();
  const { enableApprovalFlowForSharedRider } = useFlags();

  if (userFeatures?.sharedBilling && enableApprovalFlowForSharedRider) {
    return <SharedBillingFormV2 riderId={riderId} useAccounts={useAccounts} useOrganizers={useOrganizers} />;
  } else if (userFeatures?.sharedBilling && !enableApprovalFlowForSharedRider) {
    return <SharedBillingForm useAccounts={useAccounts} />;
  }

  return null;
};
